import Vue from 'vue'

export default Vue.extend({
  template: `
      <div style="padding: 4px;">
            <div v-if="params.colDef['cellRendererParams'] && params.colDef['cellRendererParams'].searchType === 'number'">
        <a-input :autoFocus="true" style="margin: 4px 0 4px 0" type="number" v-model="filterText" v-on:keyup="search($event)" v-on:keyup.enter="updateFilter($event)"  placeholder="Filter..."/>
      </div>
      <div v-else>
        <a-input :autoFocus="true" style="margin: 4px 0 4px 0" type="text" v-model="filterText" v-on:keyup="search($event)" v-on:keyup.enter="updateFilter($event)"  placeholder="Filter..."/>
      </div>
      <div align="right" class="m-1">
      <a-button type="primary" v-if="this.params.colDef['cellRendererParams'] && params.colDef['cellRendererParams'].filter" @click="updateFilter" :disabled="!filterText || filterText.trim()===''">Search</a-button>
      <a-button type="primary" @click="clear" style="font-weight: bold;background: none;color: #71283e;">Clear</a-button>
      </div>
      </div>
    `,
  data: function () {
    return {
      filterText: undefined,
    }
  },
  methods: {
    clear() {
      this.filterText = undefined
      this.updateFilter()
    },
    search() {
      if (!this.params.colDef['cellRendererParams'] || !this.params.colDef['cellRendererParams'].filter) {
        this.params.filterChangedCallback()
      }
    },
    updateFilter() {
      this.params.filterChangedCallback()
      this.params.api.refreshHeader()
    },
    doesFilterPass(params) {
      // make sure each word passes separately
      let passed = true
      if (!this.params.colDef['cellRendererParams'].filter) {
        this.filterText
          .toLowerCase()
          .split(' ')
          .forEach((filterWord) => {
            const value = this.params.valueGetter(params)
            if (value && value.toString().toLowerCase().indexOf(filterWord) < 0) {
              passed = false
            }
            if (!value) {
              passed = false
            }
          })
      }
      return passed
    },
    isFilterActive() {
      return this.filterText != null && this.filterText.trim() !== ''
    },
    getModel() {
      const data = {
        filter: !this.filterText || this.filterText.trim() === '' ? undefined : this.filterText.trim(),
        filterType: 'text',
        type: 'contains',
      }
      return data
    },
    setModel(model) {
      this.filterText = model && model.trim() !== '' ? model.value : undefined
    },
  },
})
